import { render, staticRenderFns } from "./u-dialog.vue?vue&type=template&id=a3d48332&scoped=true&"
import script from "./u-dialog.vue?vue&type=script&lang=js&"
export * from "./u-dialog.vue?vue&type=script&lang=js&"
import style0 from "./u-dialog.vue?vue&type=style&index=0&id=a3d48332&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d48332",
  null
  
)

export default component.exports